// extracted by mini-css-extract-plugin
export default {"hotspot-anchor":"ChallengeLearningOutcomeSection_hotspot-anchor__KMmg-"};